import { FormCard } from "core/cards/formCard";
import { SelectContainer } from "core/components/inputWithAccessControl";
import { useLoading } from "core/hooks/loadingHook";
import { useSubmitForm } from "core/hooks/submitFormHook";
import { addDefaultOption } from "core/utility/util";
import { formatArrayToOptions } from "core/utility/util";
import { useMasterListState } from "features/masterList/masterListProvider";
import Joi from "joi";
import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { fetchGuestTokenForDashboard } from "./analyticsService";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { toast } from "react-toastify";


export const SupersetDashboard = () => {
    const { loaderContainer, startLoading, stopLoading } = useLoading();
    const { dashboards } = useMasterListState();
    const [selectedDashboard, setSelectedDashboard] = useState(null);
    const child1 = useRef(null);
    const delay = ms => new Promise(res => setTimeout(res, ms));
    // console.log("dashboardList", dashboards)

    // Node Type Options
    const dashboardList = _.map(dashboards, "firstName");
    const dashboardOptions = addDefaultOption(formatArrayToOptions(dashboardList));



    const schema = Joi.object({
        dashboardName: Joi.string().trim().label("Dashboard Name").required(),

    });

    let defaultInputs = { id: 0 };

    const {
        inputs,
        errors,
        handleInputChange,
    } = useSubmitForm(schema, defaultInputs);

    const fetchCustomGuestToken = async (dashboard) => {
        const dynamicNodeId = 748;
        try {
            // Use the properties of the selected dashboard to create the token payload
            const tokenPayload = {
                resources: [
                    {
                        id: dashboard.supersetId,
                        type: "dashboard",
                    },
                ],
                rls: [

                ],
                user: {
                    first_name: dashboard.firstName,
                    last_name: dashboard.lastName,
                    username: dashboard.userName,
                },
            };
            console.log(tokenPayload);
            const { data } = await fetchGuestTokenForDashboard(tokenPayload);
            const newToken = data.body.token;
            // console.log("token", newToken);
            await delay(1000);

            return newToken;

        } catch (error) {
            if (error.message === "Invalid token specified") {
                console.error("Invalid token specified:", error);
                toast.error('Invalid token specified.');
            } else if (error.isAxiosError && error.response) {
                // Axios error with a response from the server
                console.error("Axios error with status code:", error.response.status);
                // toast.error(`Server error: ${error.response.status}`);
                toast.error("Dashboard Not Found!");
            } else {
                // Other types of errors
                console.error("Error fetching data or embedding dashboard:", error);
                toast.error('Error fetching or embedding dashboard.');
            }
        }
    };


    useEffect(() => {
        const embedDashboardIfNeeded = async () => {
            if (selectedDashboard) {
                startLoading();

                // Fetch the custom guest token
                const token = await fetchCustomGuestToken(selectedDashboard);
                // Embed the dashboard only if the token is valid
                if (token) {
                    embedDashboard({
                        id: selectedDashboard.supersetId,
                        supersetDomain: "http://192.168.0.15:8089",
                        mountPoint: child1.current,
                        fetchGuestToken: () => fetchCustomGuestToken(selectedDashboard), // Use the fetched token
                        dashboardUiConfig: {
                            hideTitle: false, hideTab: false,
                        },
                    });
                }

                stopLoading();
            }
        };

        // Call the new function to embed the dashboard with the valid token
        embedDashboardIfNeeded();
    }, [selectedDashboard]);




    const handleDashboardSelect = async (name, value) => {
        const selectedDashboard = dashboards.find(dashboard => dashboard.firstName === value);
        setSelectedDashboard(selectedDashboard);
        handleInputChange(name, value);
    };

    useEffect(() => {
        // If there's only one dashboard, select it by default
        if (dashboardOptions.length === 2) {
            handleDashboardSelect("dashboardName", dashboardOptions[1].value);
        }
    }, []);


    const FormHtml = (

        <div className="columns is-multiline ml-5 mr-5 dash-overlay" >
            <div className=" is-one-third is-offset-one-quarter pt-5 ">
                <SelectContainer
                    identifier="dashboardName"
                    handleInputChange={handleDashboardSelect}
                    inputs={inputs}
                    required={false}
                    errors={errors}
                    editAccess={true}
                    options={dashboardOptions}
                    defaultValue={dashboardOptions.length === 2 ? dashboardOptions[1].value : undefined}
                />
            </div>
            {/* /.column */}
        </div>

    );

    return (
        <React.Fragment >
            <div>{FormHtml}</div>
            {selectedDashboard &&
                <div className="App">

                    <div className="superset-container" ref={child1}></div>
                </div>
            }
            {loaderContainer}
        </React.Fragment>
    );
};
